import axios from 'axios';
import {responseErrorHandler, responseHandler} from "@/services/api/interceptor/responseHandler";

const instance = axios.create({
    headers: {
        common: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            Pragma: 'no-cache',
            Expires: '0',
        }
    }
});

instance.interceptors.response.use(responseHandler, responseErrorHandler);

export default instance;
